import React, {useEffect, useRef, useState} from 'react';
import clsx from "clsx";
import {KTSVG} from "../../../../_metronic/helpers";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {useFormik} from "formik";
import {getCaptcha, requestPassword, requestPasswordSubmit} from "../core/_requests";
import * as Yup from "yup";
import Countdown from "react-countdown";
import {SwalError} from "../../../../_metronic/helpers/components/Swal";
const secondsToHHMMSS = (seconds:any) => {
    if (seconds < 3600)
        return new Date(seconds * 1000).toISOString().substr(14, 5);

    return new Date(seconds * 1000).toISOString().substr(11, 8);
};
const initialValueSubmit = {
    token: '',

    captcha: '',
    newPassword: ''
}
const SubmitPasswordSchema = Yup.object().shape({

    captcha: Yup.string()
        .min(4, ' تصویر امنیتی وارد شده معتبر نمیباشد')
        .max(4, 'تصویر امنیتی وارد شده معتبر نمیباشد')
        .required('تصویر امنیتی اجباری میباشد'),
    token: Yup.string()
        .min(4, ' کد امنیتی وارد شده معتبر نمیباشد')
        .max(4, 'کد امنیتی وارد شده معتبر نمیباشد')
        .required('کد امنیتی اجباری میباشد'),
    newPassword: Yup.string()
        .min(6, ' کلمه عبور وارد شده معتبر نمیباشد')
        .max(10, 'کلمه عبور وارد شده معتبر نمیباشد')
        .required('کلمه عبور اجباری میباشد'),
})
const SubmitPasswordForgot = () => {
    const [loading, setLoading] = useState(false)
    const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
    const [mobile, setMobile] = useState<string>('');
    const navigate = useNavigate();
    const [captcha, setCaptcha] = useState("");
    async function refreshCaptcha() {
        try {
            const {data: captchaData} = await getCaptcha();
            setCaptcha(captchaData);
        } catch {

        }
    }
    const formReset = useFormik({
        initialValues: initialValueSubmit,
        validationSchema: SubmitPasswordSchema,
        onSubmit: (values) => {
            setLoading(true)
            setHasErrors(undefined)
            setTimeout(() => {

                requestPasswordSubmit(mobile, values.captcha, values.token, values.newPassword)
                    .then(({data: {result}}) => {
                        setHasErrors(false)
                        setLoading(false) ;
                        navigate('/auth/login')
                    })
                    .catch(() => {
                        setHasErrors(true)
                        setLoading(false)

                    })
            }, 0)
        }
    })
    const [searchParams] = useSearchParams();
    const timerRef = useRef();
    const buttonRef = useRef(null);
    const [currentTime, setCurrentTime] = useState(0);
    useEffect(() => {
        return () => {
            clearInterval(timerRef.current);
        };

    }, []);
    const startTimer = () => {
        // @ts-ignore
        timerRef.current = setInterval(() => {
            setCurrentTime((prev) => prev - 1);
        }, 1000);
    };
    useEffect(() => {
        if (currentTime === 0) {
            clearInterval(timerRef.current);
        }
    }, [currentTime]);
    const bindReset = async ()=>{
        try {
            setLoading(true)
            await requestPassword(mobile,formReset.values.captcha)
            setLoading(false)
        }
        catch (err:any){
            setLoading(false)
            SwalError(err?.response.date.message)
        }
    }
    const reSendCode = (e:any)=>{
        if(captcha == null || captcha.length < 4 || captcha == undefined)
            SwalError('لطفا تصویر امنیتی را وارد نمایید')
        else
            bindReset().then(()=>{
            handleStart(e)
        }).catch((err)=>{})
    }
    const handleStart = (e?:any) => {
        if(e !=null)
            e.preventDefault();

        if (timerRef.current) {
            clearInterval(timerRef.current);
        }

        const secondsInput = 120;
        setCurrentTime(() => secondsInput);
        startTimer();
    };
    useEffect(()=>{
     const data = searchParams.get('mobile')
        if (data == null)
            navigate('/auth/forgot-password')
        setMobile(data || '')
        handleStart()
    },[])
    return (
        <form
            className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
            noValidate
            id='kt_login_password_reset_form'
            onSubmit={formReset.handleSubmit}
        >
            <div className='text-center mb-10'>
                {/* begin::Title */}
                <h1 className='text-dark mb-3'>بازیابی رمز عبور</h1>
                {/* end::Title */}

                {/* begin::Link */}
                <div className='text-gray-400 fw-semibold fs-4'>لطفاً شماره موبایلی که با آن ثبت نام کرده اید
                    وارد
                    نمایید .
                </div>
                {/* end::Link */}
            </div>

            {/* begin::Title */}
            {hasErrors === true && (
                <div className='mb-lg-15 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>
                        اطلاعات وارد شده معتبر نمیباشد ، لطفاً مجددا تلاش نمایید
                    </div>
                </div>
            )}

            {hasErrors === false && (
                <div className='mb-10 bg-light-info p-8 rounded'>
                    <div className='text-info'>کد امنیتی جهت بروز رسانی رمز عبور به شماره تماس شما ارسال گردید
                    </div>
                </div>
            )}
            {/* end::Title */}

            {/* begin::Form group */}
            <div className='fv-row mb-10'>
                <label className='form-label fw-bold text-gray-900 fs-6'>کد امنیتی </label>
                <input

                    type='text'
                    placeholder=''
                    autoComplete='off'
                    {...formReset.getFieldProps('token')}
                    className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {'is-invalid': formReset.touched.token && formReset.errors.token},
                        {
                            'is-valid': formReset.touched.token && !formReset.errors.token,
                        }
                    )}
                />
                {formReset.touched.token && formReset.errors.token && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formReset.errors.token}</span>
                        </div>
                    </div>
                )}
                <div>

                    <div className="time">{secondsToHHMMSS(currentTime)}
                        {currentTime == 0 && ( <a ref={buttonRef} className="p-3 link-primary cursor-pointer" onClick={reSendCode} >ارسال مجدد کد </a>)}
                    </div>



                </div>
            </div>
            {/* end::Form group */}
            {/* begin::Form group */}
            <div className='fv-row mb-10'>
                <label className='form-label fw-bold text-gray-900 fs-6'>رمز عبور جدید </label>
                <input
                    type='password'
                    placeholder=''
                    autoComplete='off'
                    {...formReset.getFieldProps('newPassword')}
                    className={clsx(
                        'form-control form-control-lg form-control-solid',
                        {'is-invalid': formReset.touched.newPassword && formReset.errors.newPassword},
                        {
                            'is-valid': formReset.touched.newPassword && !formReset.errors.newPassword,
                        }
                    )}
                />
                {formReset.touched.newPassword && formReset.errors.newPassword && (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{formReset.errors.newPassword}</span>
                        </div>
                    </div>
                )}
            </div>
            {/* end::Form group */}
            {/* begin::Form group */}
            <div className='fv-row mb-10 row'>
                <div className="col-6">
                    <label className='form-label fs-6 fw-bold text-dark'>تصویر امنیتی</label>

                    <input
                        placeholder='تصویر امنیتی '
                        {...formReset.getFieldProps('captcha')}
                        className={clsx(
                            'form-control form-control-lg form-control-solid ',
                            {'is-invalid': formReset.touched.captcha && formReset.errors.captcha},
                            {
                                'is-valid': formReset.touched.captcha && !formReset.errors.captcha,
                            }
                        )}
                        type='text'
                        name='captcha'
                        autoComplete='off'
                    />
                    {formReset.touched.captcha && formReset.errors.captcha && (
                        <div className='fv-plugins-message-container'>
                            <span role='alert'>{formReset.errors.captcha}</span>
                        </div>
                    )}
                </div>

                <div className="col-6 ">
                    <label className='form-label fs-6 fw-bold text-dark'>تصویر </label>
                    <div className="row">
                        <div className="col-8">
                            <img src={captcha} className="col-8"/>
                        </div>
                        <div className="col-4">
                            <button type="button" onClick={refreshCaptcha} className="btn btn-light-primary me-3">

                                <KTSVG path='/media/icons/duotune/arrows/arr029.svg' className='svg-icon-2'/>

                            </button>
                        </div>

                    </div>


                </div>

            </div>
            {/* end::Form group */}


            {/* begin::Form group */}
            <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
                <button
                    type='submit'
                    id='kt_password_reset_submit'
                    className='btn btn-lg btn-primary fw-bold me-4'
                >
                    <span className='indicator-label'>تایید</span>
                    {loading && (
                        <span className='indicator-progress'>
                لطفاً منتظر بمانید...
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
                    )}
                </button>
                <Link to='/auth/login'>
                    <button
                        type='button'
                        id='kt_login_password_reset_form_cancel_button'
                        className='btn btn-lg btn-light-primary fw-bold'
                        disabled={formReset.isSubmitting || !formReset.isValid}
                    >
                        لغو
                    </button>
                </Link>{' '}
            </div>
            {/* end::Form group */}
        </form>
    );
};

export default SubmitPasswordForgot;